import React, { Component } from 'react';
import { NativeTypes } from 'react-dnd-html5-backend';
import { DropTarget } from 'react-dnd';

import { FolderOutlined } from '@ant-design/icons';

import { ItemTypes } from '../../../../constants/constants';

import { fileOwnerTypes } from '../../../../../../shared/constants/enums';
import { siteUrls, systemFolderType } from '../../../../../../shared/constants';

import api from '../../../../s3-connector/api';

import { getFilesWebkitDataTransferItems, getDirTreeFromFilePaths, getGroupedFilesByFolder } from '../../../../../../shared/utils/files';
import { showRenameSelectedFilesModal } from '../../../../../../shared/utils/files/upload-helper';
import { isGuid } from '../../../../../../shared/utils';


class LocationBarItem extends Component {
  render() {
    const { connectDropTarget, nodeData, isOver, canDrop } = this.props;

    const classes = ['oc-fm--location-bar__item'];

    if (isOver && canDrop) {
      classes.push('oc-fm--location-bar__item--drop-over');
    }

    const content = (
      <div>
        <div className={classes.join(' ')}>
          <FolderOutlined style={{ marginRight: '5px' }} />
          {nodeData.title}
        </div>
        {nodeData.policyId && nodeData.systemFolderType === systemFolderType.POLICY_FOLDER ? (
          <a
            href={siteUrls.getPolicyDetailsUrl(this.props.controlConfiguration.isMomentumEnabled, nodeData.policyId, nodeData.isPolicyQuote)}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {nodeData.isPolicyQuote ? 'Go To Quote' : 'Go To Policy'}
          </a>
        ) : nodeData.truckingCompanyId && isGuid(nodeData.truckingCompanyId) && nodeData.systemFolderType === systemFolderType.SENT_CERTIFICATES ? (
          <a
            href={siteUrls.sentCerticatesList(this.props.controlConfiguration.isMomentumEnabled, nodeData.truckingCompanyId)}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            Go To COI History
          </a>
        ) : null}
      </div>
    );

    return connectDropTarget(content);
  }
}

const itemDropTarget = {
  canDrop(props, monitor) {
    const sourceItem = monitor.getItem();
    const targetItem = props;

    if (sourceItem.ids && sourceItem.ids.findIndex((i) => i === targetItem.nodeData.key) >= 0) {
      return false;
    }

    if (
      sourceItem.items &&
      sourceItem.files &&
      (+props.ownerType === fileOwnerTypes.InsuredDefaultFolderStructure || +props.ownerType === fileOwnerTypes.PolicyDefaultFolderStructure)
    ) {
      return false;
    }

    return (
      targetItem.nodeData.type === ItemTypes.Directory &&
      targetItem.nodeData.capabilities.canAddChildren &&
      (targetItem.permissions ? targetItem.permissions.filePermissions.canAdd : false)
    );
  },

  drop(props, monitor, component) {
    if (monitor.didDrop() || !monitor.canDrop()) {
      return;
    }

    const itemType = monitor.getItemType();

    if (itemType === 'file_or_folder' || itemType === ItemTypes.Directory) {
      const sourceItemIds = monitor.getItem().ids;
      const targetItemId = props.nodeData.key;
      const handleMoveItems = props.onMoveItems;

      // internal drag-n-drop
      if (sourceItemIds && sourceItemIds.length && targetItemId) {
        handleMoveItems(sourceItemIds, targetItemId);
      }
    } else if (itemType === NativeTypes.FILE) {
      const targetItemId = props.nodeData.key;
      const items = monitor.getItem().items;
      const uploadFiles = props.onUploadDropedFiles;
      const droppedFiles = monitor.getItem().files;
      const isAllMsgFiles = droppedFiles.every((f) => f.name.endsWith('.msg') && f.type === '');
      if (isAllMsgFiles) {
        uploadFiles(targetItemId, droppedFiles, null, null);
      } else {
        getFilesWebkitDataTransferItems(items).then((files) => {
          const paths = files.map((a) => a.filepath);
          const dirTree = getDirTreeFromFilePaths(paths);

          const createFolderTree = (files, targetItemId, dirTree) => {
            api.createFolderTree(targetItemId, dirTree).then((createFolderTreeResut) => {
              const groupedFilesByFolder = getGroupedFilesByFolder(createFolderTreeResut.data, files);
              for (const folderId in groupedFilesByFolder) {
                const filesByFolder = groupedFilesByFolder[folderId].files;
                if (folderId && filesByFolder) {
                  uploadFiles(folderId, filesByFolder, targetItemId, filesByFolder.length);
                }
              }
            });
          };

          const rootfolderNames = _.uniqBy(dirTree.filter((f) => !f.isFile).map((d) => d.name));
          if (rootfolderNames.length) {
            api.getFilesInDestinationFolder(null, rootfolderNames, targetItemId).then((existingFiles) => {
              const existingfileNames = _.uniqBy(existingFiles, 'name').map((x) => x.name);
              if (existingfileNames.length) {
                showRenameSelectedFilesModal(existingfileNames, props.rootContainer, () => {
                  createFolderTree(files, targetItemId, dirTree);
                });
              } else {
                createFolderTree(files, targetItemId, dirTree);
              }
            });
          } else {
            createFolderTree(files, targetItemId, dirTree);
          }
        });
      }
    }

    return { moved: true };
  },
};

export default DropTarget(['file_or_folder', NativeTypes.FILE], itemDropTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  isOverCurrent: monitor.isOver({ shallow: true }),
  canDrop: monitor.canDrop(),
  itemType: monitor.getItemType(),
}))(LocationBarItem);
